function timer() {
    var date = $(".counter").attr("data-counter");
    var endDate = new Date(date);
    endDate = (Date.parse(endDate) / 1000);
    var today = new Date();
    today = (Date.parse(today) / 1000);

    var timeLeft = endDate - today;

    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
    var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
    var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

    if (hours < "10") {
        hours = "0" + hours;
    }

    if (minutes < "10") {
        minutes = "0" + minutes;
    }

    if (seconds < "10") {
        seconds = "0" + seconds;
    }

    if(days < 0 || hours < 0 || minutes < 0 || seconds < 0){
        $(".counter").html("No time left!");
    }

    $("#days").html("<p>" + days + " <span class='time-text'>дни</span> <span>:&nbsp;</span></p>");
    $("#hours").html("<p> " + hours + " <span class='time-text'>часове</span> <span>:&nbsp;</span></p>");
    $("#minutes").html("<p> " + minutes + " <span class='time-text'>минути</span></p>");
    $("#seconds").html("<p> " + seconds + " <span class='time-text'>секунди</span></p>");
}


setInterval(function() { timer(); }, 1000);